export default function LoadingStars({
    animate = false,
    speed = '2.5',
    width = '100%',
}: {
    animate?: boolean;
    speed?: string;
    width?: string;
}) {
    return (
        <svg
            width={width}
            height={width}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <style>
                {`
                   @keyframes twinkle1Move {
                        0% {
                            transform: translate(0, 0) scale(1);
                        }
                        33.33% {
                            transform: translate(0, 15px) scale(1); /* approximate downward to twinkle2 */
                        }
                        66.66% {
                            transform: translate(-18px, 15.65px) scale(2); /* move toward twinkle3 */
                        }
                        100% {
                            transform: translate(0,0) scale(1); /* move toward twinkle3 and scale up */
                        }
                    }

                    @keyframes twinkle2Move {
                        0% {
                            transform: translate(0, 0) scale(1);
                        }
                        33.33% {
                            transform: translate(-18px, -14.15px) scale(2); /* approximate downward to twinkle2 */
                        }
                        66.66% {
                            transform: translate(0px, -15px) scale(1); /* move toward twinkle3 */
                        }
                        100% {
                            transform: translate(0,0) scale(1); /* move toward twinkle3 and scale up */
                        }
                    }

                    @keyframes twinkle3Move {
                        0% {
                            transform: translate(0, 0) scale(1);
                        }
                        33.33% {
                            transform: translate(9px, -7.9px) scale(.5); /* approximate downward to twinkle2 */
                        }
                        66.66% {
                            transform: translate(9px, 7.1px) scale(.5); /* move toward twinkle3 */
                        }
                        100% {
                            transform: translate(0,0) scale(1); /* move toward twinkle3 and scale up */
                        }
                    }

                    .twinkle1.animate {
                        animation: twinkle1Move ${speed}s ease-in-out infinite;
                        transform-origin: center;
                    }

                    .twinkle2.animate {
                        animation: twinkle2Move ${speed}s ease-in-out infinite;
                        transform-origin: center;
                    }

                    .twinkle3.animate {
                        animation: twinkle3Move ${speed}s ease-in-out infinite;
                        transform-origin: center;
                    }
                `}
            </style>
            <g id="Sparkles">
                {/* Small sparkles */}
                <path
                    className={`twinkle1 ${animate ? 'animate' : ''}`}
                    d="M19.5 0L20.7154 3.28459L24 4.5L20.7154 5.71541L19.5 9L18.2846 5.71541L15 4.5L18.2846 3.28459L19.5 0Z"
                    fill="url(#paint1_linear_179_36077)"
                />
                <path
                    className={`twinkle2 ${animate ? 'animate' : ''}`}
                    d="M19.5 15L20.7154 18.2846L24 19.5L20.7154 20.7154L19.5 24L18.2846 20.7154L15 19.5L18.2846 18.2846L19.5 15Z"
                    fill="url(#paint2_linear_179_36077)"
                />
                {/* Main star */}
                <path
                    className={`twinkle3 ${animate ? 'animate' : ''}`}
                    d="M9 3.75L11.4308 10.3192L18 12.75L11.4308 15.1808L9 21.75L6.56918 15.1808L0 12.75L6.56918 10.3192L9 3.75Z"
                    fill="url(#paint0_linear_179_36077)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_179_36077"
                    x1="9"
                    y1="3.75"
                    x2="9"
                    y2="21.75"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#9747FF" />
                    <stop offset="1" stopColor="#0C69EA" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_179_36077"
                    x1="19.5"
                    y1="0"
                    x2="19.5"
                    y2="9"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#9747FF" />
                    <stop offset="1" stopColor="#0C69EA" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_179_36077"
                    x1="19.5"
                    y1="15"
                    x2="19.5"
                    y2="24"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#9747FF" />
                    <stop offset="1" stopColor="#0C69EA" />
                </linearGradient>
            </defs>
        </svg>
    );
}
